
<template lang="html">
    <div class="gpscontainer-box" >

      <!-- <ul>
          <li>11</li>
          <li>22</li>
          <li>33</li>
      </ul>
      <p id='ps'>conten</p> -->

      <!--查询条件-->
       <el-row class="rows" >
               <el-col :span="6">
                   <el-col :span="6" class="cell-label">设备ID</el-col>
                   <el-col :span="16" class="cell-content">
                      <el-input class='shebeiinput' placeholder v-model="params.imei"></el-input>
                   </el-col>
               </el-col>
               <el-col :span="6">
                 <el-col :span="6" class="cell-label">领用状态</el-col>
                 <el-col :span="16" class="cell-content">
                   <el-select  v-model="params.allotStatus"  placeholder="请选择" filterable clearable class="sel" ref="selClas">
                     <el-option   key="0" label="全部" value="-99" > </el-option>
                     <el-option   key="1" label="已领用" value="1" > </el-option>
                     <el-option   key="2" label="未领用" value="0" > </el-option>
                   </el-select>
                 </el-col>
             </el-col>
             <el-col :span="6" v-if="userType == 1" >
               <el-col :span="6" class="cell-label">已分配企业</el-col>
               <el-col :span="16" class="cell-content"  >
               <!-- <el-select  v-model="params.allotCompanyId"  placeholder="请选择" filterable clearable class="sel" ref="selClas">
                 <el-option  > </el-option>
               </el-select> -->
               </el-col>
           </el-col>
           <el-col :span="6">
             <el-col :span="6" class="cell-label">设备类型</el-col>
             <el-col :span="16" class="cell-content">
             <el-select  v-model="params.type"  placeholder="请选择" filterable clearable class="sel" ref="selClas">
               <el-option   key="0" label="全部" value="-99" > </el-option>
               <el-option   key="1" label="普通类型" value="1" > </el-option>
               <el-option   key="2" label="可远程控制" value="2" > </el-option>
               <el-option   key="3" label="OBD" value="3" > </el-option>
             </el-select>
             </el-col>
         </el-col>



       </el-row>
       <!--权限按钮-->
       <el-row class="tool-bar el-row">
             <Permission code='1207011401,22020401,32021001'>
               <pl-button size="small" @click="addGpsById()">新增</pl-button>
             </Permission>
             <Permission code='1207011402,22020402,32021002'>
               <pl-button v-if="changeMap" size="small" @click="editGpsById()">编辑</pl-button>
               <pl-button v-else size="small huibage">编辑</pl-button>
             </Permission>
             <Permission code='1207011403'>
               <pl-button v-if="changeMap" size="small" @click="complanById()">分配企业</pl-button>
                <pl-button v-else size="small huibage">分配企业</pl-button>
             </Permission>
              <Permission code='1207011401,22020401,32021001'>
               <pl-button v-if="changeMap" size="small" @click='collect'>领用设备</pl-button>
                <pl-button v-else size="small huibage">领用设备</pl-button>
             </Permission>
              <Permission code='1207011401,22020401,32021001'>
               <pl-button v-if="changeMap" size="small"  @click='returnEquipment'>归还设备</pl-button>
                <pl-button v-else size="small huibage">归还设备</pl-button>
             </Permission>
             <div style="float: right">
                 <pl-button icon="el-icon-refresh" size="small" @click="clear">重置</pl-button>
                 <pl-button type="primary" icon="el-icon-search" size="small" @click="initDeliverList">查询</pl-button>
             </div>
       </el-row>
       <!--列表数据-->
       <el-table v-loading="loading" ref="mapTable" :data="gpsData"
        size="mini" highlight-current-row border
        @selection-change="handleSelectionChange"
         class="table">
            <el-table-column type="selection" width="45" ></el-table-column>
            <el-table-column  prop="imei" label="设备ID" width="150" align="center" ></el-table-column>
            <el-table-column  prop="type" label="设备类型" width="150" align="center" >
              <template slot-scope="scope">
                   {{returnImeiType(scope.row.type)}}
              </template>
            </el-table-column>
            <el-table-column  prop="allotStatus" label="领用状态" width="150" align="center" >
              <template slot-scope="scope">{{scope.row.allotStatus == 1 ? '已领用' : '未领用'}}</template>
            </el-table-column>
            <el-table-column  prop="allotPlateNo" label="已领用车牌" width="200" align="center" ></el-table-column>
            <el-table-column  prop="allotDriverName" label="已领用司机" width="200" align="center" ></el-table-column>
            <el-table-column  prop="runStatus" label="运行状态" width="200" align="center" >
              <template slot-scope="scope">{{scope.row.runStatus == 1 ? '正常' : '异常'}}</template>
            </el-table-column>
            <el-table-column  prop="allotCompanyName" label="已分配企业" width="200" align="center" ></el-table-column>
            <el-table-column  prop="ownerCompanyName" label="所属企业" width="200" align="center" ></el-table-column>
            <el-table-column  prop="" label="操作记录" width="200" align="center">
            <template slot-scope="scope">
      <span style="color: #086FFD;cursor: pointer;" @click="viewRecords(scope.row.id)">查看记录</span>
      </template>
          </el-table-column>
        </el-table>

        <!--新增及编辑设备-->
        <el-dialog center title="新增设备"  :visible.sync="addDialogFormVisible" width="500px">
          <el-form :model="addGpsForm" :rules="rules"  ref="ruleForm" label-width="100px" size="mini" >
            <el-form-item label="设备ID" prop="imei">
              <el-col :span="20">
                <el-input v-model="addGpsForm.imei" autocomplete="off"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="设备类型" prop="type">
              <el-col :span="20">
                <el-select  v-model="addGpsForm.type"  placeholder="请选择" filterable clearable class="sel" ref="selClas">
                  <el-option
                    v-for="(item,index) in gpsTypeList"
                    :key="index"
                    :label="item.compName"
                    :value="item.compName">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item>
             <el-button type="primary" @click="doAdd('ruleForm')">确 定</el-button>
             <el-button @click="addDialogFormVisible = false">取 消</el-button>
           </el-form-item>
          </el-form>
        </el-dialog>

         <!--分配设置到企业-->
        <el-dialog center title="分配企业"  :visible.sync="planDialogFormVisible" width="30%">
            <el-form :model="comOsForm" :rules="rules"  ref="ruleForm" label-width="100px" size="mini" >
              <el-row :gutter="20">

                <el-col :span="12">
                   <el-form-item label="分配企业" prop="imei">
                  <el-select  v-model="comOsForm.allotCompanyName" @change='company' placeholder="请选择" filterable clearable class="sel" ref="selClas">
                    <el-option
                      v-for="(item,index) in gpsTypeList"
                      :key="index"
                      :label="item.typeCode"
                      :value="item.compName">
                    </el-option>
                  </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="部门" prop="department">
                      <el-select  v-model="comOsForm.department" placeholder="请选择"  filterable clearable class="sel" ref="selClas">
                    <el-option
                      v-for="(item,index) in departmentList"
                      :key="index"
                      :label="item.orgName"
                      :value="item.compId">
                    </el-option>
                  </el-select>
                  </el-form-item>
                </el-col>

              </el-row>
            </el-form>
             <span slot="footer" class="dialog-footer">
              <el-button @click="planDialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="distribution">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog  title="领用设备"  :visible.sync="collectVisible" width="55%">
            <div class='content-box'>
               <div class='box1 pulic'>
                  <div class='head'>
                    <div class='line'></div>
                    <span>司机信息</span>
                  </div>
                 <el-row :gutter="20">
                    <el-form ref="form" :model="lineData" label-width="80px">
                       <el-col :span="12">
                      <el-form-item label="设备ID">
                      <el-input v-model="lineData.imei"></el-input>
                     </el-form-item>
                       </el-col>
                     <el-col :span="12">
                      <el-form-item label="领用车牌">
                      <el-input  id='carNum' @blur='focusEvent' v-model="lineData.allotPlateNo"></el-input>
                     </el-form-item>
                       </el-col>
                        <el-col :span="12">
                      <el-form-item label="司机手机号">
                      <el-input  @blur='phoneEvent' id='phoneId' v-model="lineData.allotDriverPhone"></el-input>
                     </el-form-item>
                       </el-col>
                        <el-col :span="12">
                      <el-form-item label="司机姓名">
                      <el-input disabled v-model="lineData.allotDriverName"></el-input>
                     </el-form-item>
                       </el-col>
                    </el-form>
                </el-row>
                  </div>

              <div class='box2 pulic'>
                  <div class='head'>
                    <div class='line'></div>
                    <span>关联货源</span>
                  </div>
                <el-row :gutter="20">
                    <el-form ref="relationData" :model="relationData" label-width="80px">
                       <el-col :span="12">
                      <el-form-item label="货物名称">
                      <el-input v-model="relationData.name"></el-input>
                     </el-form-item>
                       </el-col>
                     <el-col :span="12">
                      <el-form-item label="发货省市">
                      <el-cascader
                        :options="options"
                        clearable
                        class="sel"
                          v-model="relationData.sProvince"
                        @change="onSelectedOne"
                     ></el-cascader>
                     </el-form-item>
                       </el-col>
                        <el-col :span="12">
                      <el-form-item label="收货省市">
                          <el-cascader :options="options" v-model="relationData.rProvince" @change="onSelectedsh" ></el-cascader>
                     </el-form-item>
                       </el-col>
                        <el-col :span="12">
                      <el-form-item label="货源编码">
                      <el-input v-model="relationData.number"></el-input>
                     </el-form-item>
                       </el-col>
                    </el-form>
                </el-row>

                 <div class="btn-box" style='display: flex;justify-content: flex-end;padding-bottom: 10px;'>
                    <el-button type="primary" size="small" icon="el-icon-search" @click='queryCollect'>查询</el-button>
                    <el-button type="primary" size="small" icon="el-icon-refresh-left">重置</el-button>
                </div>

             <el-table
                :data="collectData"
                 border
                style="width: 100%"
                @selection-change="handleSelectionChange2"
               >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
            <el-table-column prop="cargoNo" label="货源编码" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="matName" label="货物名称" align="center"></el-table-column>
            <el-table-column prop="allotPlateNo" label="发货量" align="center"></el-table-column>
            <el-table-column prop="allotDriverName" label="计量单位" align="center"></el-table-column>
            <el-table-column prop="efenceNames" label="托运方" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="carrName" label="承运方" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="senderProvince" label="发货省市" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="senderCity" label="发货地址" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="receiverProvince" label="收货省市" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="receiverCity" label="收货地址" align="center" show-overflow-tooltip></el-table-column>
            </el-table-column>
          </el-table>
              </div>

            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="collectVisible = false">取 消</el-button>
              <el-button type="primary" @click="ConfirCollection">确 定</el-button>
          </span>
        </el-dialog>

         <el-dialog  title="归还设备"  :visible.sync="equipmentVisible" width="400px">
            <el-form :model="returnData" ref="returnData" label-width="50px" size="mini" >
              <el-form-item label="设备ID" prop="imei">
                <el-input v-model="returnData.name"></el-input>
              </el-form-item>
            </el-form>
             <span slot="footer" class="dialog-footer">
              <el-button @click="equipmentVisible = false">取 消</el-button>
              <el-button type="primary" @click="equipment">确 定</el-button>
          </span>
        </el-dialog>


        <el-dialog center title="操作记录"  :visible.sync="viewVisible" width="35%">
            <el-table
                ref="multipleTable"
                :data="operationData"
                 border
                style="width: 100%"
               >
            <el-table-column prop="taskId" label="操作人" align="center"></el-table-column>
            <el-table-column prop="imei" label="操作时间" align="center"></el-table-column>
            <el-table-column prop="allotPlateNo" label="操作" align="center"></el-table-column>
            <el-table-column prop="allotDriverName" label="领用车牌" align="center"></el-table-column>
            <el-table-column prop="efenceNames" label="司机名称" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="carrName" label="司机手机号"  align="center"></el-table-column>
            <el-table-column prop="senderCity" label="发货省市" align="center"></el-table-column>
            <el-table-column prop="senderCddress" label="关联货源" align="center"></el-table-column>
            </el-table-column>
          </el-table>
             <span slot="footer" class="dialog-footer">
              <el-button @click="viewVisible = false">取 消</el-button>
              <el-button type="primary" @click="viewVisible = false">确 定</el-button>
          </span>
        </el-dialog>
    </div>
</template>
<script>
import minix from "../../minix";
import Permission from "../../components/common/permission"; //按钮权限
import { post, get, dict } from "../../api/ajax";
import { Message } from "element-ui";
import PlButton from "../../components/common/button";
import { logger } from "../../utils/log"; //日志
import { areaData } from "../../api/areaData";
// import { provinceAndCityData, CodeToText } from "element-china-area-data"; //省市信息
export default {
  components: {
    Permission,
    PlButton
  },
  data() {
    return {
      loading: true,
      receiveType: true,
      datachange: "", //控制确定按钮
      gpsData: [], //设备列表
      options2: [],
      options3: [],
      options4: [],
      multipleSelection: [],
      multipleSelection2: [], //领用设备查询
      userType: this.$store.state.sharing.userInfo.userType,
      sharing: JSON.parse(localStorage.getItem("login")),
      changeMap: false, //只能一次调整一个
      params: {
        imei: Number(-99),
        allotCompanyId: Number(-99),
        type: Number(-99),
        runStatus: Number(-99),
        allotStatus: Number(-99)
      },
      addGpsForm: {
        imei: "",
        vendorId: 1,
        type: ""
      },
      comOsForm: {
        imei: "",
        allotCompanyId: "",
        allotOrgId: "",
        allotCompanyType: 2,
        relativeCompanyId: "",
        relativeCompanyName: "",
        relativeOrgId: "",
        relativeCompanyType: "",
        department: ""
      },
      gpsTypeList: [], //公司数据
      departmentList: [], //部门数据
      addDialogFormVisible: false, //新增
      planDialogFormVisible: false,
      collectVisible: false, //领用设备
      lineData: {
        imei: "",
        allotPlateNo: "",
        allotDriverPhone: "",
        allotDriverName: "",
        allotVehicleIdNo: "", //车架号
        allotCompanyId: "" //已分配的公司
      },
      relationData: {
        name: "",
        number: "",
        sProvince: "",
        rProvince: ""
      },
      options: areaData,
      sProvince: "",
      rProvince: "",
      collectData: [],
      equipmentVisible: false, //归还
      returnData: {
        name: ""
      },
      operationData: [],
      viewVisible: false,
      rules: {
        imei: [{ required: true, message: "请填写设备ID", trigger: "blur" }],
        type: [{ required: true, message: "请选择设备类型", trigger: "change" }]
      },
      queryList: {
        cargoId: "",
        carrId: "",
        carrName: "",
        carrOrgId: "",
        senderId: "",
        senderName: "",
        senderOrgId: "",
        senderCity: "",
        senderProvince: "",
        receiverCity: "",
        receiverProvince: ""
      },
      rentInfo: {
        allotCompanyId: "",
        allotCompanyName: ""
      },
      collection: {
        allotOrgId: "",
        allotCompanyType: ""
      },
      isShow:true,
      plateNoData:'',

    };
  },

  mounted() {
    //初始化列表
    this.getGpsDataList();
  },
  methods: {
    handleOndragstart(event){
        console.log(event);

    },
    handleOndragend(){

    },
    //获取分配企业 -- 公司数据
    getCorporateName() {
      //  let params = {
      //   userType:this.$store.state.sharing.userInfo.userType
      // }
      post("/api/au/company/findCompNames"
      ).then(res => {
        // console.log(res);
        this.gpsTypeList = res.items;
        // console.log(this.gpsTypeList);
      });
    },
    //获取部门参数
    company() {
      this.gpsTypeList.map(item => {
        if (this.comOsForm.allotCompanyName == item.compName) {
          this.rentInfo.allotCompanyId = item.id; //公司id
          this.collection.allotCompanyType = item.userType; //公司类型
        }
      });

      //获取分配企业 -- 部门数据
      let params = {
        compId: this.rentInfo.allotCompanyId
      };
      post("/api/au/org/findByComp",
        params
      ).then(res => {
        console.log(res);
        this.departmentList = res;
      });
    },

    //分配确认
    distribution() {
      this.multipleSelection.map(item => {
        this.lineData.imei = item.imei;
      });
      console.log(this.lineData)
      let params = {
        imei: this.lineData.imei,
        allotCompanyId: this.rentInfo.allotCompanyId,
        allotCompanyName: this.comOsForm.allotCompanyName,
        allotOrgId: this.comOsForm.department,
        allotCompanyType: this.collection.allotCompanyType,
        ownerCompanyId:  0
      };
      post("/api/sh/service/locator/allotToCompany",
        params
      ).then(res => {
        console.log(res);
        if (res == 1) {
          this.$message({
            type: "success",
            message: "分配企业成功！"
          });
          this.planDialogFormVisible = false;
          this.$refs.mapTable.clearSelection(); // 删除后清空之前选择的数据
        } else {
          this.$message({
            type: "error",
            message: "分配企业失败！"
          });
        }
      });
    },

    //监听领用车牌输入事件
    focusEvent() {
      let carNums = document.getElementById("carNum");
      if (carNums.value.length >= 7) {
        let params = {
          plateNo: this.lineData.allotPlateNo
        };
        post("/api/md/vehicle/get", params).then(res => {
          console.log(res);
          this.plateNoData = res.plateNo
          this.lineData.allotDriverName = res.ownerName; //领用司机名字
          this.lineData.allotVehicleIdNo = res.vehicleIdNo; //车架号
        });
      } else {
        this.$message({
          type: "error",
          message: "领用车牌输入不匹配"
        });
      }
    },

    //监听司机手机号输入事件
    phoneEvent() {
      let phoneIds = document.getElementById("phoneId");
      if (phoneIds.value.length == 11) {
        let params = {
         licenseId: this.plateNoData,
         mobile:this.lineData.allotDriverPhone,
         status:1,
        }
        console.log(params);

        post("/api/md/driver/find",params).then(
          res => {
            console.log(res);
            this.lineData.allotDriverId = res.items.id;
          }
        );
      } else {
        this.$message({
          type: "error",
          message: "手机号输入有误"
        });
      }
    },

    getGpsDataList() {
      var that = this;
      post("/api/sh/service/locator/query", {
        ...that.params
      }).then(res => {
        console.log(res);
        var list = res.retContent || [];
        that.gpsData = list;
        that.loading = false;
      });
    },
    //新增
    doAdd(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //提交
          let that = this;
          let con = "";
          if (that.datachange == "add") {
            con = "add";
          } else {
            con = "edit";
          }
          console.log(con);
          post("/api/sh/service/locator/" + con, {
            ...that.addGpsForm
          }).then(res => {
            that.$message({
              message: "新增成功",
              type: "success"
            });
            that.addDialogFormVisible = false;
            that.getGpsDataList();
            that.addGpsForm = {
              imei: "",
              vendorId: 1,
              type: ""
            };
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addGpsById() {
      this.addDialogFormVisible = true;
      this.datachange = "add";
    },

    //编辑
    editGpsById() {
      this.addDialogFormVisible = true;
      this.datachange = "edit";
    },

    //领用设备
    collect() {
      this.collectVisible = true;
      this.multipleSelection.map(item => {
        this.lineData.imei = item.imei;
        this.lineData.allotCompanyId = item.allotCompanyId;

        // this.lineData.allotPlateNo = item.allotPlateNo;
      });
    },

    //领用设备--查询
    queryCollect() {
      let params = {
        matName: this.relationData.name,
        receiverCity: this.sProvince,
        senderCity: this.rProvince,
        cargoNo: this.relationData.number
      };
      post("/api/tm/cargo/findContions",
        params
      ).then(res => {
        console.log(res);
        this.collectData = res.items;
      });
    },
    handleSelectionChange2(val) {
      console.log(val);
      this.multipleSelection2 = val;
    },

    //领用设备确定事件
    ConfirCollection() {
      let items = {};
      this.multipleSelection2.map(item => {
        items = item;
      });
      let params = {
        imei: this.lineData.imei,
        allotDriverId: this.lineData.allotDriverId, //领用司机的dirverId
        allotDriverPhone: this.lineData.allotDriverPhone,
        allotDriverName: this.lineData.allotDriverName,
        allotPlateNo: this.lineData.allotPlateNo,
        allotVehicleIdNo: this.lineData.allotVehicleIdNo, //车架号


        allotCompanyId: this.lineData.allotCompanyId,
        cargoId: items.cargoId,
        carrId: items.carrId,
        carrName: items.carrName,
        carrOrgId: items.carrOrgId,
        senderId: items.senderId,
        senderName: items.senderName,
        senderOrgId: items.senderOrgId,
        senderCity: items.senderCity,
        senderProvince: items.senderProvince,
        receiverCity: items.receiverCity,
        ownerCompanyId: 0,
        receiverProvince: items.receiverProvince
      };
      post("/api/sh/service/locator/allotToDriver",
        params
      ).then(res => {
        console.log(res);
        if (res == 1) {
          this.$message({
            type: "success",
            message: "设备领用成功"
          });
        } else {
          this.$message({
            type: "error",
            message: "设备领用失败！"
          });
        }
        this.collectVisible = false;
      });
    },

    //归还设备
    returnEquipment() {
      this.equipmentVisible = true;
      this.multipleSelection.map(item => {
        this.returnData.name = item.imei;
      });
    },

    //归还确认事件
    equipment() {
      let imei = "";
      let allotCompanyId = ""
      this.multipleSelection.map(item => {
        imei = item.imei;
        allotCompanyId = item.allotCompanyId
      });
      let params = {
        imei: imei || this.returnData.name,
        companyId: allotCompanyId,
      };
      post("/api/sh/service/locator/disallotFromDriver",
        params
      ).then(res => {
        if (res == 1) {
          this.$message({
            type: "success",
            message: "设备归还成功"
          });
          this.equipmentVisible = false;
          this.getGpsDataList();
        } else {
          this.$message({
            type: "error",
            message: "设备归还失败"
          });
        }
      });
    },

    // 选择发货省市
    onSelectedOne(value) {
      console.log(value);
      this.sProvince = value[0] + value[1];
    },
    // 选择收货货省市
    onSelectedsh(value) {
      this.rProvince = value[0] + value[1];
      console.log(this.rProvince);
    },
    //查看记录
    viewRecords(id) {
      this.viewVisible = true;
    },
    returnImeiType(type) {
      if (type == 1) {
        return "普通";
      } else if (type == 2) {
        return "可远程控制";
      } else {
        return "OBD";
      }
    },
    handleSelectionChange(val) {
      //勾选
      let that = this;
      that.multipleSelection = val;
      val.forEach(item=>{
        console.log(item);
        if(item.runStatus == 1) {
          this.isShow = false
        }

      })
      if (that.multipleSelection.length > 1) {
        that.changeMap = false;
      } else {
        that.changeMap = true;
        // console.log(val);
        that.addGpsForm.imei = val[0].imei;
        that.addGpsForm.type = val[0].type;
        this.$forceUpdate();
      }
    },
    initDeliverList() {
      //查询
      this.getGpsDataList();
    },
    clear() {
      //重置
      this.params = {
        imei: -99,
        allotCompanyId: -99,
        type: -99,
        runStatus: -99,
        allotStatus: -99
      };
    },
    complanById() {
      this.planDialogFormVisible = true;
      this.getCorporateName();
    }
  }
};
</script>
<style lang="scss" scoped>
.gpscontainer-box {
  .rows {
    margin-top: 10px;
    padding-bottom: 10px;
  }
  .cell-label {
    position: relative;
    top: 12px;
  }
  .shebeiinput {
    position: relative;
    top: 6px;
  }
  .huibage {
    border: 1px solid #ccc;
    color: #ccc;
  }
  .sel {
    position: relative;
    top: 6px;
  }

  .content-box {
    .box1 {
      margin-bottom: 10px;
    }
    .pulic {
      border: 1px solid #e4e3e3;
      padding: 8px 10px;
    }
    .line {
      height: 15px;
      line-height: 15px;
      width: 2px;
      background-color: #9349a9;
      display: inline-block;
      margin-right: 3px;
    }
    .el-form-item {
      margin-bottom: 0;
    }
    .el-cascader {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/basicData/gpsEquipment.vue